module.exports = __webpack_public_path__ + "img/icon-eth-gray.c93dc3af.svg";